import { type ClassValue, clsx } from 'clsx';
import { EMAIL_PARTNER_WHITELIST } from 'src/lib/constants';
import { twMerge } from 'tailwind-merge';
import { Difficulty } from 'src/lib/api/generated/schemas';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isEmailPartner(partner?: string | null) {
  if (!partner) return false;
  return EMAIL_PARTNER_WHITELIST.includes(partner?.toLowerCase());
}

export const getDifficultyColour = (difficulty: Difficulty | null) => {
  switch (difficulty) {
    case Difficulty.EASY:
      return '#D8FFA7';
    case Difficulty.MEDIUM:
      return '#FFCF96';
    case Difficulty.DIFFICULT:
      return '#FFA7A7';
    default:
      return '#D8FFA7';
  }
};

type PhaseType = 'warmup' | 'cooldown';

const WARMUP_TEXT = 'Calentamiento';
const COOLDOWN_TEXT = 'Enfriamiento';
const WARMUP_BG_COLOR = '#FEF5E7';
const COOLDOWN_BG_COLOR = '#F5F7FC';
const WARMUP_TEXT_COLOR = '#FF6883';
const COOLDOWN_TEXT_COLOR = '#AF95EE';
const WARMUP_DESCRIPTION = 'Evita lesiones con el calentamiento perfecto';
const COOLDOWN_DESCRIPTION = 'Evita sobrecargas con el enfriamiento perfecto.';

export const getPhaseDetails = (type: PhaseType) => {
  return {
    text: type === 'warmup' ? WARMUP_TEXT : COOLDOWN_TEXT,
    bgColor: type === 'warmup' ? WARMUP_BG_COLOR : COOLDOWN_BG_COLOR,
    textColor: type === 'warmup' ? WARMUP_TEXT_COLOR : COOLDOWN_TEXT_COLOR,
    description: type === 'warmup' ? WARMUP_DESCRIPTION : COOLDOWN_DESCRIPTION,
  };
};
